- const { parent } = properties
- const { columns, page, perPage } = parent.data[parent.api].competitions
- const total = (parent.filteredCompetitions || []).flat().length

.filters
  .item
    label Filter by ID
    ft-form-control(
      placeholder='ID',
      type='number',
      [(value)]=parent.data[parent.api].competitions.filter.id,
      (input)=parent.filterOn('competitions', 'id', e.target.value)
    )
  .item
    label Filter by name
    ft-form-control(
      placeholder='Name',
      type='text',
      [(value)]=parent.data[parent.api].competitions.filter.name,
      (input)=parent.filterOn('competitions', 'name', e.target.value)
    )
  .item
    ft-button(
      danger,
      (click)=parent.resetFilter('competitions')
    ) Reset
  .item
    label Total rows
    span= total

table.competitions
  thead
    th
      each column in columns
        td: span= parent.columnize(column)
  tbody
    each row in parent.filteredCompetitions[page]
      tr
        if parent.api === 'gamescorekeeper'
          td.id
            ft-button(href=parent.linkTo({ tab: 'competition', id: row.id }))
              span= row.id
          td: span= row.name
          td: span= row.sportAlias
          td: span
            if row.startDate
              = parent.moment(row.startDate).format(parent.dateFormat)
          td: span
            if row.endDate
              = parent.moment(row.endDate).format(parent.dateFormat)

ft-pagination(
  primary=true,
  display=4,
  current=page,
  (currentChanged)=parent.setPage(e.target.current, 'competitions'),
  size=perPage,
  total=total
)